import React from "react";
import { withRouter } from "react-router-dom";
import IconLogoFooter from "../Resources/svg/Icons/IconLogoFooter";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div className="footer">
      <div className="wrap">
        <div className="content-box">
          <div className="footer__content">
            <IconLogoFooter />
            <div className="footer__text">
              © {year} RIMAC Seguros y Reaseguros.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Footer);
